import { Component, OnInit } from '@angular/core';
import { SolicitudesPorMotorizado } from '../interfaces/solicitudesPorMotorizado';
import { DataUserService } from '../Services/data-user.service';
import { DataApiService } from '../Services/data-api.service';
import {MatDialog,MatDialogConfig, MAT_DIALOG_DATA} from '@angular/material';
import { EditarServicioPorMotorizadoComponent } from '../components/dialogs/editar-servicio-por-motorizado/editar-servicio-por-motorizado.component';


@Component({
  selector: 'app-motorizado',
  templateUrl: './motorizado.component.html',
  styleUrls: ['./motorizado.component.scss']
})
export class MotorizadoComponent implements OnInit {

  constructor(
    private DataUser:DataUserService,
    private dataApi:DataApiService,  
    private dialog: MatDialog


  ) { }

  solicitudesPorMotorizado:SolicitudesPorMotorizado[];
  private id = this.DataUser.dataUser(this.dataApi.tokenUser(localStorage.getItem("token")));   
  
  ngOnInit() {
   this.obtenerUsuario(this.id)
   
  }
  obtenerUsuario(id:number){    
    this.dataApi.getUser(id).subscribe( data=>{
      console.log(data)
      const email = data["email"];
      this.dataApi.getSolicitudesPorMotorizado(email).subscribe( (data:SolicitudesPorMotorizado[])=>{
        this.solicitudesPorMotorizado = data;       
      });
    })
  }

  editar(id_pedido){
    this.dialog.open(EditarServicioPorMotorizadoComponent,{
      width:"240px",
      data:id_pedido,
      disableClose: false,
      autoFocus:true
    });  
  }
  
}
